import img1 from "../../assets/Images/Event Calender/Event-Calender.png"

export default function EventCalendar() {
    return (
        <section id="event-calendar" className="space-y-16">

            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    3. Event Calendar
                </h1>
                <p className="text-md text-slate-600 max-w-3xl">
                    The Event Calendar provides a visual overview of all scheduled events,
                    helping staff quickly identify availability, avoid conflicts, and
                    manage bookings across dates, slots, and halls.
                </p>


                {/* OVERVIEW */}
                <section className="bg-white border-l border-[#C9A24E] p-4 mt-2">
                    <h2 className="text-lg font-semibold mb-3">
                        Overview
                    </h2>
                    <p className="text-slate-600 text-sm">
                        This module displays bookings in a calendar format with both Gregorian
                        and Islamic dates. It allows users to see event distribution at a
                        glance and navigate bookings efficiently.
                    </p>
                </section>
            </section>

            {/* CALENDAR VIEW */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Calendar View
                </h3>

                <p className="text-slate-600 mb-4">
                    Upon opening the Event Calendar, a monthly calendar is displayed with
                    all scheduled events highlighted on their respective dates.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Shows Gregorian month and Islamic month together</li>
                    <li>Displays Islamic dates and special religious days</li>
                    <li>Each event date shows hall and slot (Morning / Evening)</li>
                    <li>Multiple events appear stacked on the same date</li>
                </ul>

                <div className="rounded-lg p-4 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* DATE SEARCH */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Search Event by Date
                </h3>

                <p className="text-slate-600 mb-3">
                    A date search input is available above the calendar to quickly locate
                    events scheduled on a specific day.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Date format: <strong>DD/MM/YYYY</strong></li>
                    <li>Slash ( / ) is auto-inserted for convenience</li>
                    <li>Calendar auto-navigates to the searched date</li>
                </ul>
            </section>

            {/* RIGHT PANEL */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Event Bookings Panel (Right Side)
                </h3>

                <p className="text-slate-600 mb-4">
                    On the right side of the calendar, a dedicated Event Bookings panel
                    displays a list of all bookings in a scrollable format.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Lists bookings with complete event details</li>
                    <li>Scrollable for large data sets</li>
                    <li>Shows all the booked and upcoming events</li>
                </ul>
            </section>

            {/* BOOKING SEARCH */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Booking Search
                </h3>

                <p className="text-slate-600 mb-3">
                    A search bar is provided within the Event Bookings panel to quickly
                    locate specific bookings.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Search by booking number</li>
                    <li>Search by event date</li>
                    <li>Search by slot or hall</li>
                    <li>Search by program type</li>
                </ul>
            </section>

            {/* BOOKING DETAILS */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Booking Details Display
                </h3>

                <p className="text-slate-600 mb-4">
                    Each booking card in the list shows essential information for quick
                    reference.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Booking number</li>
                    <li>Event date & day</li>
                    <li>Slot (Morning / Evening)</li>
                    <li>Hall / Portion</li>
                    <li>Program type</li>
                    <li>Total number of guests</li>
                </ul>
            </section>

            {/* ACTIONS */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Available Actions
                </h3>

                <p className="text-slate-600 mb-3">
                    Each booking entry includes action options for quick management.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        <strong>Edit</strong> — Opens the booking form for updates
                    </li>
                    <li>
                        <strong>View Invoice</strong> — Displays the generated invoice
                    </li>
                </ul>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why the Event Calendar Matters
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    The Event Calendar acts as the operational heartbeat of EventFlow. It
                    prevents double bookings, improves coordination, and gives management
                    instant visibility into venue utilization and upcoming events.
                </p>
            </section>

        </section>
    );
}
